module.exports = __webpack_public_path__ + "static/media/clone-img.aa1755ed.svg";